import { Environment } from '../enums/environment';
import { type EnvironmentConfig } from '../types/environment-config';

const ENVIRONMENT_CONFIGS: Record<Environment, EnvironmentConfig> = {
    [Environment.LOCAL]: {
        VITE_API: 'https://api-dev.gls-group.net',
        VITE_APIGEE_API_VERSION: '/attribute-store-v1/api/v1',
        VITE_AZURE_B2C_AUTHORITY: 'https://glsgrouptest.b2clogin.com/glsgrouptest.onmicrosoft.com/B2C_1A_LOCAL_SUSI',
        VITE_AZURE_B2C_CLIENT_ID: '22d1e5f1-a2ba-47af-a773-030cd71f2e91',
        VITE_AZURE_B2C_KNOWN_AUTHORITIES: 'glsgrouptest.b2clogin.com'
    },
    [Environment.DEV]: {
        VITE_API: 'https://api-dev.gls-group.net',
        VITE_APIGEE_API_VERSION: '/attribute-store-v1/api/v1',
        VITE_AZURE_B2C_AUTHORITY: 'https://glsgrouptest.b2clogin.com/glsgrouptest.onmicrosoft.com/B2C_1A_LOCAL_SUSI',
        VITE_AZURE_B2C_CLIENT_ID: '22d1e5f1-a2ba-47af-a773-030cd71f2e91',
        VITE_AZURE_B2C_KNOWN_AUTHORITIES: 'glsgrouptest.b2clogin.com'
    },
    [Environment.STAGE]: {
        VITE_API: 'https://api-qas.gls-group.net',
        VITE_APIGEE_API_VERSION: '/attribute-store-v1/api/v1',
        VITE_AZURE_B2C_AUTHORITY: 'https://glsgrouptest.b2clogin.com/glsgrouptest.onmicrosoft.com/B2C_1A_LOCAL_SUSI',
        VITE_AZURE_B2C_CLIENT_ID: '22d1e5f1-a2ba-47af-a773-030cd71f2e91',
        VITE_AZURE_B2C_KNOWN_AUTHORITIES: 'glsgrouptest.b2clogin.com'
    },
    [Environment.PROD]: {
        VITE_API: 'https://api.gls-group.net',
        VITE_APIGEE_API_VERSION: '/attribute-store-v1/api/v1',
        VITE_AZURE_B2C_AUTHORITY: 'https://glsgroup.b2clogin.com/glsgroup.onmicrosoft.com/B2C_1A_LOCAL_SUSI',
        VITE_AZURE_B2C_CLIENT_ID: '1cebb0a8-67e4-4843-8b08-586997efa985',
        VITE_AZURE_B2C_KNOWN_AUTHORITIES: 'glsgroup.b2clogin.com'
    }
};

export { ENVIRONMENT_CONFIGS };
